import * as _ from 'lodash';
import moment from 'moment';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import EmojiPicker from '../../../libs/emoji/emoji-picker';

const logoPath = 'resources/images/cartonomy-icon.svg';

export default class ChatDirectiveController {
    static $inject = ['$scope', 'CatalogChatService', '$state', 'Message', '$timeout', 'Session', 'LocalForageService', '$', 'ConfigurationService', 'CartService', '$rootScope', 'OrderSetupService'];

    constructor(scope, catalogChatService, stateService, messageService, timeoutService, Session, localForageService, $, configurationService, cartService, rootScope, orderSetupService) {

        this._catalogChatService = catalogChatService;
        this._scope = scope;
        this._stateService = stateService;
        this._cartService = cartService;
        this._messageService = messageService;
        this._sessionService = Session;
        this._configurationService = configurationService;
        //this._sessionStorageService = SessionStorage;
        this._localForageService = localForageService;
        this.currentClientTime = new Date();
        this.currentClientTimeCount = new Date().getTime();
        this._rootScope = rootScope;
        this._orderSetupService = orderSetupService;
        scope.copyClipboard = () => this._copyClipboard();


        scope.participants = [];
        scope.messages = [];
        scope.newMessage = '';
        scope.compactMode = stateService.is(Constants.RoutingStates.CATALOG);
        scope.maxTextLength = Constants.MAXIMUM_CHAT_TEXT_LENGTH;
        scope.refreshing = false;
        scope.selectedParticipants = [];
        this._sessionService.getUserEmail().then(result => scope.currentLoggedInUserEmail = result);
        this.jQuery = $;

        scope.getTimeForMessage = (messageUTCTime) => {
            let currentTime = new Date().getTime();
            return (new Date(messageUTCTime).getTime() > currentTime) ? currentTime : messageUTCTime;
        };

        scope.participantsFilter = () => this._participantsFilter();
        scope.selectAllParticipants = () => this._selectAllParticipants();
        scope.checkedAllParticipants = () => this._checkedAllParticipants();

        scope.isSvg = (path) => {
            return !!path && path.indexOf(logoPath) > -1;
        };
        scope.$on('$destroy', async () => {
            await this._catalogChatService.startWatchingOnUnreadMessage();
        });

        scope.$on(Constants.Events.WINDOW_STATE_CHANGED, async (scope, state) => {
            if (state === Constants.WindowMode.maximized) {
                await this._catalogChatService.stopWatchingForUnreadMessage();
            }
        });

        scope.$on(Constants.Events.REALTIME_CHAT_RECEIVED, (scope) => {
            timeoutService(() => this._onChatUpdated(), 1);
        });

        scope.postMessage = async (event) => this._postMessage(event);

        scope.onMessageTextAreaKeyPress = (event) => {
            if (event.which === 13) {
                return this._postMessage(event).then(() => {
                    return;
                });
            }
        };

        scope.showMore = () => this._showMore();

        this._refreshTimes = 0;
        this._lastRefreshTime = null;
        this.emojiEditor = null;
        this.emojiArea = null;
        scope.isStealthUserMode = this._sessionService.getStealthUserMode();
    }

    async $onInit() {
        this._rootScope.storeWindowTitle = 'Group Chat';
        new EmojiPicker({
            emojiable_selector: '[data-emojiable=true]',
            assetsPath: '/resources/emoji-data/emoji-picker/img',
            popupButtonClasses: 'fa fa-smile-o',
            onLoaded: (emojiEditor, emojiArea) => {

                if (this._scope.isStealthUserMode && emojiEditor) {
                    emojiEditor[0].setAttribute("placeholder", 'You are viewing this cart and cannot send messages');
                    emojiEditor[0].setAttribute("disabled", 'disabled');
                }

                this.emojiEditor = emojiEditor;
                this.emojiArea = emojiArea;
            },
            onKeyUp: async (event, emojiEditor) => {
                scopeUtils.apply(this._scope, () => {
                    this._scope.newMessage = emojiEditor.html();
                });

                if (event.which === 13) {
                    this._scope.newMessage = emojiEditor.html();
                    await this._postMessage(event);
                }
            }
        }).discover();

        await this._refreshData();

        this._refreshTimes = 0;
        this._lastRefreshTime = null;
        this._scope.$on(Constants.Events.SIGNALR_CONNECTED, async (scope) => {
            if (this._lastRefreshTime && moment(this._lastRefreshTime).diff(moment(), 'seconds', true) <= 20 && this._refreshTimes >= 3) {
                window.location.reload(true);
                return;
            }
            this._refreshTimes++;
            this._lastRefreshTime = new Date();

            if (this._signalrConnectedTimeOut) {
                clearTimeout(this._signalrConnectedTimeOut);
            }

            this._signalrConnectedTimeOut = setTimeout(() => this._refreshData(), 500);
        });

        this._scope.$on(Constants.Events.USER_JOINED_OTHER_CART, async (scope) => {
            await this._refreshData();
        });
    }

    async _refreshData() {
        if(this._orderSetupService.invitationPromise) {
            await this._orderSetupService.invitationPromise;
        }
        this._scope.refreshing = true;
        let cart = await this._sessionService.getCartReference();
        //if(this._scope.isStealthUserMode){
        if (cart && cart.id != 0) {
            await this._catalogChatService.updateByCartId(cart.id);
        } else {
            await this._catalogChatService.update();
        }

        //}
        // else{
        //   await this._catalogChatService.updateByCartId(cart.id);
        // }
        await this._catalogChatService.stopWatchingForUnreadMessage();
        await this._onChatUpdated();
        setTimeout(() => {
            if((document.querySelector('.msg_container_base')))
                (document.querySelector('.msg_container_base')).scrollTop = (document.querySelector('.msg_container_base')).scrollHeight;
        }, 100);
    }

    _showMore() {
        this._stateService.go(Constants.RoutingStates.CHAT);
    }

    async _copyClipboard() {
        this._cartService.copyClipboard(this._scope.invitationLink);
    }

    async _postMessage(event) {

        if (event) {
            event.preventDefault();
        }

        // hide emoji before posting messages
        if (this.emojiArea && this.emojiArea.emojiMenu) {
            this.emojiArea.emojiMenu.hide();
        }

        //CW-2552 & CW-2553: issues relates to microsoft edge . added .replace('<br>','')
        if (this._scope.newMessage === '<br>')
            this._scope.newMessage = this._scope.newMessage.replace('<br>', '');

        const newMessage = _.trim(this._scope.newMessage);
        if (newMessage.length) {
            try {
                let userData = await this._localForageService.retrieve(Constants.SessionStorage.USER_DATA);
                const user = JSON.parse(userData);
                const newMessageObj = {
                    message: newMessage,
                    name: user.fullName,
                    isSending: true,
                    avatarCropped: user.avatarCropped,
                    avatar: user.avatarSrc,
                    createdOn: new Date()
                };

                this._scope.messages.splice(0, 0, newMessageObj);

                scopeUtils.apply(this._scope, () => {
                    this._scope.newMessage = '';

                    this.emojiEditor && this.emojiEditor.empty && this.emojiEditor.empty();
                });
                let res = await this._catalogChatService.postMessage(newMessage);

                if (res && res.data && res.data.id) {
                    newMessageObj.isSending = false;
                }
            } catch (error) {

            } finally {
                scopeUtils.apply(this._scope, () => {
                });
                setTimeout(() => {
                    (document.querySelector('.msg_container_base')).scrollTop = (document.querySelector('.msg_container_base')).scrollHeight;
                }, 100);
            }
        }
    }

    _participantsFilter() {
        if (this._scope.selectedParticipants.length > 0) {
            let results = this._scope.messages.filter(r => this._scope.selectedParticipants.indexOf(r.email) > -1 || r.email === this._scope.currentLoggedInUserEmail);
            return results;
        } else {
            return [];
        }
    }

    _selectAllParticipants() {
        if (this._scope.checkedAllParticipants()) {
            this._scope.selectedParticipants = [];
        } else {
            this._scope.selectedParticipants = this._scope.participants.map(r => {
                return r.email
            });
        }
    }

    _checkedAllParticipants() {
        return this._scope.participants.length === this._scope.selectedParticipants.length;
    }

    _onChatUpdated = async () => {
        setTimeout(() => {
            if(document.querySelector('.msg_container_base') && document.querySelector('.msg_container_base')) {
                (document.querySelector('.msg_container_base')).scrollTop = (document.querySelector('.msg_container_base')).scrollHeight;
            }
        }, 100);
        this._scope.refreshing = true;
        let newMessages = await this._catalogChatService.getMessages();
        if (this._scope.messages.length <= newMessages.length) {
            this._scope.messages = newMessages;
        }
        this._scope.hasMore = false;

        if (this._scope.compactMode && this._scope.messages.length > Constants.CHAT_MESSAGES_LIMIT) {
            this._scope.messages = _.slice(this._scope.messages, this._scope.messages.length - Constants.CHAT_MESSAGES_LIMIT);
            this._scope.hasMore = true;
        }

        if (!this._scope.messages.length) {
            this._scope.participants = [];
            // this._scope.refreshing = false;
            scopeUtils.apply(this._scope);
            return;
        }

        _.each(this._scope.messages, (message) => {
            message.name = message.Name || message.name || message.Email || message.email;
            message.email = message.Email || message.email;
            message.message = this._formatMessage(message.Message) || this._formatMessage(message.message);
            message.isMy = message.email === this._scope.currentLoggedInUserEmail;

            // message.message = message.message.replace('target="_parent"', 'target="_blank"');

            message.iconLetter = message.name[0];
            message.avatarCropped = message.avatarCropped || message.AvatarCropped;
            message.avatar = message.avatar || message.Avatar;
        });

        this._scope.participants = _.chain(this._scope.messages)
            .map(m => _.pick(m, ['email', 'name']))
            .uniqWith(_.isEqual)
            .sortBy('name')
            .value();
        this._scope.selectedParticipants = this._scope.participants.map(r => {
            return r.email
        });

        this._scope.refreshing = false;
        scopeUtils.apply(this._scope);
    };

    _formatMessage(message) {
        if(!message) {
            return message;
        }

        let utcLabelIndex = message.indexOf(Constants.CHAT_TIME_LABEL);
        if(utcLabelIndex !== -1) {
            let timeString = message.substr(message.indexOf('(', utcLabelIndex) + 1, message.indexOf(')', utcLabelIndex) -  (message.indexOf('(', utcLabelIndex)) - 1);
            let timeStringFormated = moment(timeString).format('dddd, MMM Do, YYYY [at] hh:mm A');
            return message.replace(Constants.CHAT_TIME_LABEL+'(' + timeString + ')', timeStringFormated);

        }

        return message;
    }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/directives/ChatDirective.js